import { useEffect } from "react";
import { useLang } from "@/lib/i18n";
import { SITE_URL } from "@/content/site";

const setMeta = (selector, attr, value, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(create.tag);
    Object.entries(create.attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export function useSeo(key, override) {
  const { t, lang, base } = useLang();
  const [title, desc] = override || t.seo[key] || t.seo.home;
  useEffect(() => {
    const origin = SITE_URL;
    document.title = title;
    document.documentElement.lang = lang;
    document.documentElement.dir = t.dir;
    setMeta('meta[name="description"]', "content", desc, { tag: "meta", attrs: { name: "description" } });
    setMeta('meta[property="og:title"]', "content", title, { tag: "meta", attrs: { property: "og:title" } });
    setMeta('meta[property="og:description"]', "content", desc, { tag: "meta", attrs: { property: "og:description" } });
    setMeta('meta[property="og:locale"]', "content", lang === "ar" ? "ar_LY" : "en_GB", { tag: "meta", attrs: { property: "og:locale" } });
    const enUrl = origin + base;
    const arUrl = origin + (base === "/" ? "/ar" : `/ar${base}`);
    const self = lang === "ar" ? arUrl : enUrl;
    setMeta('link[rel="canonical"]', "href", self, { tag: "link", attrs: { rel: "canonical" } });
    setMeta('meta[property="og:url"]', "content", self, { tag: "meta", attrs: { property: "og:url" } });
    setMeta('meta[name="twitter:title"]', "content", title, { tag: "meta", attrs: { name: "twitter:title" } });
    setMeta('meta[name="twitter:description"]', "content", desc, { tag: "meta", attrs: { name: "twitter:description" } });
    setMeta('link[hreflang="x-default"]', "href", enUrl, { tag: "link", attrs: { rel: "alternate", hreflang: "x-default" } });
    setMeta('link[hreflang="en"]', "href", enUrl, { tag: "link", attrs: { rel: "alternate", hreflang: "en" } });
    setMeta('link[hreflang="ar"]', "href", arUrl, { tag: "link", attrs: { rel: "alternate", hreflang: "ar" } });
  }, [title, desc, lang, base, t.dir]);
}
